import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  cancelButton: {
    color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
    fontWeight: isKiteUser ? '400' : '600',
    textDecoration: 'none',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    padding: 0,
    backgroundColor: 'transparent !important',

    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  address: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  totalItems: {
    color: theme.palette.red,
  },
}));
